import React, { forwardRef, useCallback, useMemo } from 'react';
import { withStyles, Theme, MenuItem, ListItemText } from '@material-ui/core';
import { RecordOptionsProps, RecordOptionProps } from 'components/SelectOptions/type';
import CodeVO from 'commons/vo/CodeVO';
import { RecordOptionType } from 'components/Select/type';
import { ScriptOptions } from 'commons/constants/KeyFlowConstants';

const StyledMenuItem = withStyles((theme: Theme) => ({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#D94F98',
      borderBottom: '1px solid #ffffff',
      '& > *': {
        color: '#ffffff',
      },
    },
    '&:focus': {
      backgroundColor: '#D94F98',
      borderBottom: '1px solid #ffffff',
      // '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      //   color: theme.palette.common.white,
      // },
    },
  },
}))(MenuItem);

function Option({ record, selectedRecords, onClick }: RecordOptionProps) {
  const isActive = useMemo(() => {
    const index = selectedRecords.findIndex(
      (selectedRecord: string) => selectedRecord === record.value,
    );
    return index !== -1;
  }, [selectedRecords, record]);

  const onClickItem = useCallback(() => {
    onClick(record.value);
  }, [onClick, record]);
  return (
    <StyledMenuItem onClick={onClickItem} selected={isActive}>
      <ListItemText>{record.value}</ListItemText>
    </StyledMenuItem>
  );
}

function RecordOptions({ selectedRecords, onClickRecord }: RecordOptionsProps) {
  return (
    <>
      {ScriptOptions.map((record: RecordOptionType) => (
        <Option
          key={record.id}
          record={record}
          selectedRecords={selectedRecords}
          onClick={onClickRecord}
        />
      ))}
    </>
  );
}

export default RecordOptions;
